import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from 'app/shared.service';

@Component({
  selector: 'app-login-alert',
  templateUrl: './login-alert.component.html',
  styleUrls: ['./login-alert.component.scss']
})
export class LoginAlertComponent implements OnInit {
  public loginUrl: string = `/meinkonto/login/?order=true&redirect=${encodeURIComponent(
    window.location.href
  )}`;
  public env: string;

  @Input()
  public showLoginPhrase: boolean = true;

  constructor(private sharedService: SharedService) {
    this.env = this.sharedService.getEnvironment();
  }

  ngOnInit() {}
}
